import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]

import BlockView from "@/views/share/BlockView.vue";
import {ref} from "vue";
import ScrollPagerView from "@/views/share/ScrollPagerView.vue";
import {Waterfall} from "vue-waterfall-plugin-next";
import 'vue-waterfall-plugin-next/dist/style.css'
import TemplateCardView from "@/views/main/segments/TemplateCardView.vue";
import {useRoute} from "vue-router";
import {Main} from "@/model/main";
import {Material} from "@/model/material";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainTemplateSegView',
  setup(__props) {


const route = useRoute()
const main = useRoute().meta.main as Main
const material = route.meta.material as Material


const wf: any = ref()
const setRefMap = (el: any) => {
  wf.value = el
}

const imgOnLoad = () => {
  wf.value.renderer()
}

return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createBlock(BlockView, { style: {"flex":"1","width":"calc(100% - 440px)"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_breadcrumb, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(main).active.args.path.map(e => _unref(material).tags.tags[e].name).slice(0,2), (i) => {
            return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: i }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(i), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(main).active.components, (cs, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "filter-row",
          key: i
        }, [
          _createVNode(ScrollPagerView, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: 16 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cs, (mo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item", {'active':_unref(main).active.args.path[i+2]==mo.tag}]),
                      key: mo.tag,
                      onClick: ($event: any) => (_unref(main).onFilterChanged(i+2,mo.tag))
                    }, _toDisplayString(mo.name), 11, _hoisted_1))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128)),
      (_unref(main).active.scenes.length)
        ? (_openBlock(), _createBlock(_component_a_tabs, {
            key: 0,
            "active-key": _unref(main).active.args.path.last(),
            type: "card",
            "tab-bar-gutter": 8,
            class: "ts",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(main).onTabChange($event)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(main).active.scenes, (i) => {
                return (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: i.tag,
                  tab: i.name
                }, null, 8, ["tab"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["active-key"]))
        : _createCommentVNode("", true),
      (_unref(main).active.themes.length > 0)
        ? (_openBlock(), _createBlock(_unref(Waterfall), {
            key: 1,
            list: _unref(main).active.themes,
            breakpoints: _unref(main).breakPoint,
            ref: (el)=> setRefMap(el)
          }, {
            item: _withCtx(({item}) => [
              _createVNode(TemplateCardView, {
                tc: item,
                onOnLoad: imgOnLoad
              }, null, 8, ["tc"])
            ]),
            _: 1
          }, 8, ["list", "breakpoints"]))
        : (_openBlock(), _createBlock(_component_a_empty, { key: 2 }))
    ]),
    _: 1
  }))
}
}

})